<template>
    <div class="card shadow">
        <div class="card-header bg-transparent">
            <div>
                <h3 class="mb-0">
                    {{ $t('message.edit') }} {{ $t('message.categoriePrestation') }}
                </h3>
            </div>
        </div>

        <div class="card-body">
            <b-form>
                <b-container>

                    <b-row>

                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="start-date-group"
                                    :label="$t('message.name')"
                                    label-for="start-date">
                                <b-form-input
                                        id="start-date"
                                        v-model="$v.form.nom.$model"
                                        :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                                        placeholder=""
                                        @focus="clearErrorField('nom')"
                                ></b-form-input>

                                <b-form-invalid-feedback v-if="errorshasField('nom')">
                                    {{ getErrorsField('nom') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-if="$v.form.nom.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                    </b-row>
                    <b-row>

                    </b-row>
                    <b-row class="justify-content-sm-center" v-if="can">
                        <b-button @click="onSubmit" variant="primary">
                            {{ $t('message.edit') }}
                        </b-button>
                    </b-row>
                </b-container>


            </b-form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {required} from "vuelidate/lib/validators";

    export default {
        name: "Edit",
        computed: {
            ...mapGetters(["categoriePrestation", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','isComptable','hasAssistante']),

            form: function () {
                return this.categoriePrestation;
            },

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },
        },

        data() {
            return {
                categorie_prestation: this.$route.params.categorie,
            }
        },

        methods: {
            getCategoriePrestation() {
                let args = {
                    categorie_prestation: this.categorie_prestation,
                };
                this.$store.dispatch("getCategoriePrestation", {args});
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        categorie_prestation: this.categorie_prestation,
                        nom: this.form.nom,
                    };

                    let successMessage = this.$i18n.t('message.categorieUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateCategoriePrestation', { args, errorMessages, successMessage })
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }

        },

        mounted() {
            this.getCategoriePrestation();
        },

        validations: {
            form: {
                nom: {
                    required
                },
            }
        },
    }
</script>

<style scoped>

</style>